import type {
    IUiSnackbarHookParams,
    SnackbarAnchorOrigin,
    SnackbarVariantType,
} from '@experiences/interfaces';
import { useSnackbar } from '@experiences/util';
import Fade from '@mui/material/Fade';
import React from 'react';

import { notificationType } from '../constants/Constant';

export const useUiSnackBar = () => {
    const { enqueueSnackbar } = useSnackbar();

    /** @deprecated Use {@link createNotificationWithOptions} instead, which accepts a single options object. */
    const createNotification = React.useCallback((
        message: string,
        type = notificationType.INPROGRESS,
        anchorOrigin: SnackbarAnchorOrigin = {
            horizontal: 'center',
            vertical: 'top',
        },
        autoHideDuration: number | null = 3000,
        dataCy?: string,
        title?: string,
    ) => {
        enqueueSnackbar(message, {
            variant: type as SnackbarVariantType,
            anchorOrigin,
            TransitionComponent: Fade,
            autoHideDuration,
            dataCy,
            title,
        });
    }, [ enqueueSnackbar ]);

    const createNotificationWithOptions = React.useCallback(
        (params: IUiSnackbarHookParams & { message: string; type?: string }) => {
            const {
                message,
                type = notificationType.INPROGRESS,
                anchorOrigin = {
                    horizontal: 'center',
                    vertical: 'top',
                },
                autoHideDuration = 3000,
                dataCy,
                title,
            } = params;

            enqueueSnackbar(message, {
                variant: type as SnackbarVariantType,
                anchorOrigin,
                TransitionComponent: Fade,
                autoHideDuration,
                dataCy,
                title,
            });
        },
        [ enqueueSnackbar ],
    );

    return {
        createNotification,
        createNotificationWithOptions,
    };
};
